// @ts-nocheck
import * as GraphQLSchema from '../graphql-types';

import * as Operations from './recommended-worker-query.graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type RecommendedWorkersQueryVariables = GraphQLSchema.Exact<{
  jobId: GraphQLSchema.Scalars['ID']['input'];
}>;


export type RecommendedWorkersQuery = { __typename?: 'Query', recommendedWorkers?: { __typename?: 'RecommendedWorkers', recommendations?: Array<{ __typename?: 'Recommendation', explanation: { __typename?: 'RecommendationExplanation', availabilityOverlap: number, overallServiceCoverage: number }, worker: { __typename?: 'WorkerProfile', about?: string | null, combinedFeedback?: number | null, deliveredHourGroup?: string | null, distanceAway?: number | null, normalizedType: string, loyaltyName?: string | null, statutoryDeclarationStatus?: boolean | null, rates?: Array<{ __typename?: 'Rate', rateCents?: number | null, rateName?: string | null }> | null, ratings?: Array<{ __typename?: 'Rating', id: string }> | null, response: { __typename?: 'Response', time?: string | null, veryResponsive?: boolean | null }, user: { __typename?: 'User', approved: boolean, displayName: string, firstName: string, id: string, normalizedType: string, permalink: string, postcode?: string | null, truncatedName: string, avatar?: { __typename?: 'Avatar', big?: string | null, small?: string | null } | null } } }> | null } | null };


  @Injectable({
    providedIn: 'root'
  })
  export class RecommendedWorkersQueryService extends Apollo.Query<RecommendedWorkersQuery, RecommendedWorkersQueryVariables> {
    document = Operations.RecommendedWorkersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }